var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { Box } from "@mui/material";
import { BODY_TEXT_COLOR, DIMMED_OPACITY } from "../utils/chartConstants";
import { formatNumericValue } from "../../../utils/chartData";
var MobileLegendList = function (_a) {
    var items = _a.items, selectedSeries = _a.selectedSeries, onItemClick = _a.onItemClick, onClear = _a.onClear;
    return (_jsxs(Box, __assign({ sx: {
            display: "grid",
            gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
            gap: 1,
            mt: 1.5,
        } }, { children: [selectedSeries.length > 0 && (_jsx(Box, __assign({ sx: {
                    gridColumn: "1 / -1",
                    display: "flex",
                    justifyContent: "flex-end",
                    mb: 0.25,
                } }, { children: _jsx(Box, __assign({ component: "button", type: "button", onClick: onClear, sx: {
                        border: "1px solid #D1D5DB",
                        background: "#fff",
                        color: "#374151",
                        borderRadius: "999px",
                        px: 1.25,
                        py: 0.45,
                        fontFamily: "Montserrat, sans-serif",
                        fontSize: "0.72rem",
                        fontWeight: 700,
                        cursor: "pointer",
                    } }, { children: "Limpar" })) }))), items.map(function (item) {
                var isSelected = selectedSeries.includes(item.name);
                var isDimmed = selectedSeries.length > 0 && !isSelected;
                return (_jsx(Box, __assign({ component: "button", type: "button", onClick: function () { return onItemClick(item.name); }, sx: {
                        textAlign: "left",
                        p: 1.25,
                        borderRadius: "10px",
                        border: "1px solid ".concat(isSelected ? item.color : "#E5E7EB"),
                        background: isSelected ? "".concat(item.color, "14") : "#fff",
                        cursor: "pointer",
                        minWidth: 0,
                        opacity: isDimmed ? DIMMED_OPACITY : 1,
                        transition: "all 0.18s ease",
                    } }, { children: _jsxs(Box, __assign({ sx: { display: "flex", alignItems: "flex-start", gap: 1 } }, { children: [_jsx(Box, { sx: {
                                    width: 10,
                                    height: 10,
                                    borderRadius: "999px",
                                    background: item.color,
                                    mt: "5px",
                                    flexShrink: 0,
                                } }), _jsxs(Box, __assign({ sx: { minWidth: 0 } }, { children: [_jsx(Box, __assign({ sx: {
                                            fontFamily: "Montserrat, sans-serif",
                                            fontSize: "0.72rem",
                                            fontWeight: 600,
                                            color: BODY_TEXT_COLOR,
                                            lineHeight: 1.35,
                                            wordBreak: "break-word",
                                        } }, { children: item.name })), _jsx(Box, __assign({ sx: {
                                            fontFamily: "Montserrat, sans-serif",
                                            fontSize: "0.82rem",
                                            fontWeight: 700,
                                            color: BODY_TEXT_COLOR,
                                            mt: 0.5,
                                        } }, { children: formatNumericValue(item.value) }))] }))] })) }), item.name));
            })] })));
};
export default MobileLegendList;
